import { NavLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { usePrimaryNavItems } from '@/app/navigation/usePrimaryNavItems';
import { isAppNavActive } from '@/app/routes/paths';

export default function MobileBottomNav() {
  const { t } = useTranslation('nav');
  const { pathname } = useLocation();
  const primaryNavItems = usePrimaryNavItems();

  return (
    <nav
      className="fixed bottom-0 start-0 end-0 z-30 border-t border-gray-300 bg-white lg:hidden"
      aria-label={t('mainNav')}
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex h-16 items-stretch justify-around">
        {primaryNavItems.map(({ label, path, Icon }) => {
          const isActive = isAppNavActive(pathname, path);

          return (
            <NavLink
              key={path}
              to={path}
              className={clsx(
                'flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-2 text-xs font-medium transition-colors',
                isActive ? 'text-brand-emphasis' : 'text-gray-500 hover:text-gray-700',
              )}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="h-6 w-6 shrink-0" aria-hidden />
              <span className="truncate">{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
